{
    "A": "A base-fret 0 frets x 0 2 2 2 0",
    "A/B": "A/B base-fret 0 frets x 2 2 2 2 0",
    "A/C#": "A/C# base-fret 0 frets x 4 2 2 2 0",
    "A/D": "A/D base-fret 0 frets x x 0 2 2 0",
    "A/E": "A/E base-fret 0 frets 0 0 2 2 2 0",
    "A/F#": "A/F# base-fret 0 frets 2 0 2 2 0 0",
    "A/G": "A/G base-fret 0 frets 3 0 2 2 0 0",
    "A/G#": "A/G# base-fret 0 frets 4 x 2 2 0 0",
    "A11": "A11 base-fret 2 frets 4 3 x 1 2 2",
    "A13": "A13 base-fret 0 frets x 0 2 0 2 2",
    "A13(b9)": "A13(b9) base-fret 3 frets 2 x 2 3 4 3",
    "A2": "A2 base-fret 0 frets x 0 2 2 0 0",
    "A2/C#": "A2/C# base-fret 0 frets x 4 2 2 0 0",
    "A2/E": "A2/E base-fret 0 frets 0 0 2 2 0 0",
    "A2/F#": "A2/F# base-fret 0 frets 2 0 2 2 0 0",
    "A2/G#": "A2/G# base-fret 0 frets 4 x 2 2 0 0",
    "Asus": "Asus base-fret 0 frets x 0 2 2 3 0",
    "Asus/E": "Asus/E base-fret 0 frets 0 0 2 2 3 0",
    "A5": "A5 base-fret 0 frets x 0 2 2 x x",
    "A5/E": "A5/E base-fret 2 frets 0 0 1 1 1 4",
    "A6": "A6 base-fret 0 frets x 0 2 2 2 2",
    "A7": "A7 base-fret 0 frets x 0 2 0 2 0",
    "Aaug7": "Aaug7 base-fret 0 frets x 0 3 2 2 1",
    "A7(#5b9)": "A7(#5b9) base-fret 3 frets 2 x 2 3 3 3",
    "A7(b5)": "A7(b5) base-fret 0 frets x 0 1 0 2 x",
    "A7/E": "A7/E base-fret 0 frets 0 0 2 0 2 0",
    "A7/G": "A7/G base-fret 0 frets 3 x 2 0 2 0",
    "A7(b9)": "A7(b9) base-fret 0 frets x 0 2 3 2 3",
    "A7sus4": "A7sus4 base-fret 0 frets x 0 2 0 3 0",
    "A7sus4/E": "A7sus4/E base-fret 0 frets 0 0 2 0 3 0",
    "A9": "A9 base-fret 0 frets x 0 2 4 0 0",
    "A9(b5)": "A9(b5) base-fret 0 frets x 0 1 4 2 3",
    "Aaug": "Aaug base-fret 0 frets x 0 3 2 2 1",
    "G#9": "G#9 base-fret 0 frets 4 3 4 3 4 x",
    "G#sus": "G#sus base-fret 0 frets 4 4 1 1 2 x",
    "G#ma9": "G#ma9 base-fret 0 frets 4 x 1 3 1 3",
    "Adim": "Adim base-fret 0 frets x 0 1 2 1 2",
    "Adim7": "Adim7 base-fret 0 frets x 0 1 2 1 2",
    "Am": "Am base-fret 0 frets x 0 2 2 1 0",
    "Am/C": "Am/C base-fret 0 frets x 3 2 2 1 0",
    "Am13": "Am13 base-fret 0 frets x 0 0 0 1 2",
    "Am6": "Am6 base-fret 0 frets x 0 2 2 1 2",
    "Am7": "Am7 base-fret 0 frets x 0 2 0 1 0",
    "Am7(b5)": "Am7(b5) base-fret 0 frets x 0 1 0 1 x",
    "Am7/G": "Am7/G base-fret 0 frets 3 x 2 0 1 0",
    "Am9": "Am9 base-fret 0 frets x 0 2 4 1 0",
    "Ama7": "Ama7 base-fret 0 frets x 0 2 1 2 0",
    "Ama9": "Ama9 base-fret 0 frets x 0 2 4 2 4",
    "B": "B base-fret 0 frets x 2 4 4 4 2",
    "B/A": "B/A base-fret 0 frets x 0 4 4 4 2",
    "B/A#": "B/A# base-fret 0 frets x 1 4 3 0 x",
    "B/C#": "B/C# base-fret 0 frets x 4 4 4 4 x",
    "B/D#": "B/D# base-fret 0 frets x x 1 4 4 2",
    "B/E": "B/E base-fret 0 frets 0 2 4 4 0 0",
    "B/F#": "B/F# base-fret 0 frets 2 2 4 4 4 2",
    "B/G#": "B/G# base-fret 0 frets 4 x 4 4 4 x",
    "B11": "B11 base-fret 0 frets x 2 1 2 0 0",
    "B13": "B13 base-fret 0 frets x 2 4 2 4 4",
    "B13(b9)": "B13(b9) base-fret 5 frets 2 x 2 3 4 3",
    "B2": "B2 base-fret 0 frets x 2 4 4 2 2",
    "B2/A#": "B2/A# base-fret 0 frets x 1 4 4 0 x",
    "B2/D#": "B2/D# base-fret 0 frets x 3 1 1 0 x",
    "B2/G#": "B2/G# base-fret 0 frets 4 x 4 4 0 x",
    "Bsus": "Bsus base-fret 0 frets x 2 4 4 0 0",
    "Bsus/F#": "Bsus/F# base-fret 0 frets 2 2 4 4 0 0",
    "B5": "B5 base-fret 0 frets x 2 4 4 0 x",
    "B5/F#": "B5/F# base-fret 0 frets 2 2 4 4 2 2",
    "B6": "B6 base-fret 0 frets x 2 4 4 4 4",
    "B6/9": "B6/9 base-fret 0 frets x 2 1 1 2 x",
    "B7": "B7 base-fret 0 frets x 2 1 2 0 2",
    "Baug7": "Baug7 base-fret 0 frets x 2 1 0 0 3",
    "B7(#5b9)": "B7(#5b9) base-fret 5 frets 2 x 2 3 3 3",
    "B7(#9)": "B7(#9) base-fret 0 frets x 2 1 2 3 x",
    "B7(b5)": "B7(b5) base-fret 0 frets x 2 3 2 4 x",
    "B7(b9)": "B7(b9) base-fret 0 frets x 2 1 2 1 x",
    "B7/A": "B7/A base-fret 0 frets x 0 1 2 0 2",
    "B7/D#": "B7/D# base-fret 0 frets x x 1 2 0 2",
    "B7/F#": "B7/F# base-fret 0 frets 2 2 4 2 4 2",
    "B7sus4": "B7sus4 base-fret 0 frets x 2 2 2 0 2",
    "B7sus4/F#": "B7sus4/F# base-fret 0 frets 2 2 4 4 0 0",
    "B7sus4/G#": "B7sus4/G# base-fret 0 frets 4 x 4 4 0 0",
    "B9": "B9 base-fret 0 frets x 2 1 2 2 2",
    "B9(b5)": "B9(b5) base-fret 0 frets x 2 1 2 2 1",
    "Baug": "Baug base-fret 0 frets x 2 1 0 0 3",
    "A#/D": "A#/D base-fret 0 frets x x 0 3 3 1",
    "A#/F": "A#/F base-fret 0 frets 1 1 3 3 3 1",
    "A#11": "A#11 base-fret 0 frets x 1 0 3 4 4",
    "A#13": "A#13 base-fret 0 frets x 1 3 1 3 3",
    "A#2": "A#2 base-fret 0 frets x 1 3 3 1 1",
    "A#2/F": "A#2/F base-fret 0 frets 1 1 3 3 1 1",
    "A#sus": "A#sus base-fret 0 frets x 1 3 3 4 1",
    "A#7": "A#7 base-fret 0 frets x 1 3 1 3 1",
    "A#aug7": "A#aug7 base-fret 0 frets x 1 4 1 3 x",
    "A#7(#5b9)": "A#7(#5b9) base-fret 5 frets 1 x 1 2 2 2",
    "A#7(#9)": "A#7(#9) base-fret 0 frets x 1 0 1 2 x",
    "A#7(b5)": "A#7(b5) base-fret 0 frets 2 x 2 3 1 x",
    "A#7/F": "A#7/F base-fret 0 frets 1 1 3 1 3 1",
    "A#9": "A#9 base-fret 0 frets x 1 3 3 1 1",
    "A#9(b5)": "A#9(b5) base-fret 0 frets x 1 0 1 1 0",
    "A#m11": "A#m11 base-fret 0 frets 4 x 4 4 2 x",
    "A#m13": "A#m13 base-fret 0 frets x 1 1 1 2 3",
    "A#m6": "A#m6 base-fret 0 frets x x x 3 2 3",
    "A#m7": "A#m7 base-fret 0 frets x 1 3 1 2 1",
    "A#m7(b5)": "A#m7(b5) base-fret 0 frets x 1 2 1 2 0",
    "A#m9": "A#m9 base-fret 0 frets x 4 3 1 1 1",
    "A#ma9": "A#ma9 base-fret 0 frets x 1 0 2 1 x",
    "Bdim": "Bdim base-fret 0 frets x 2 0 1 0 1",
    "Bdim7": "Bdim7 base-fret 0 frets x 2 0 1 0 1",
    "Bm": "Bm base-fret 0 frets x 2 4 4 3 2",
    "Bm/D": "Bm/D base-fret 0 frets x x 0 4 3 2",
    "Bm11": "Bm11 base-fret 0 frets x 2 0 2 2 0",
    "Bm13": "Bm13 base-fret 0 frets x 2 0 1 2 2",
    "Bm6": "Bm6 base-fret 0 frets x 2 0 1 0 2",
    "Bm7": "Bm7 base-fret 0 frets x 2 4 2 3 2",
    "Bm7(b5)": "Bm7(b5) base-fret 0 frets x 2 3 2 3 x",
    "Bm7/A": "Bm7/A base-fret 0 frets x 0 4 2 3 2",
    "Bm9": "Bm9 base-fret 0 frets x 2 x 2 2 2",
    "Bma7": "Bma7 base-fret 0 frets 2 2 4 3 4 2",
    "Bma9": "Bma9 base-fret 0 frets x 2 1 3 2 x",
    "C": "C base-fret 0 frets x 3 2 0 3 3",
    "C#/G#": "C#/G# base-fret 0 frets x x x 1 2 1",
    "C#11": "C#11 base-fret 0 frets x 4 3 4 2 2",
    "C#13": "C#13 base-fret 2 frets x 2 1 2 2 4",
    "C#2": "C#2 base-fret 0 frets x 4 1 1 2 x",
    "C#2/G#": "C#2/G# base-fret 3 frets 1 1 3 3 1 1",
    "C#7": "C#7 base-fret 0 frets x 4 3 4 2 x",
    "C#aug7": "C#aug7 base-fret 0 frets x 4 3 2 0 x",
    "C#7(b5)": "C#7(b5) base-fret 0 frets x 4 3 4 x 3",
    "C#7(b9)": "C#7(b9) base-fret 0 frets x 4 3 4 3 x",
    "C#7/G#": "C#7/G# base-fret 3 frets 1 1 3 1 3 1",
    "C#9": "C#9 base-fret 0 frets x 4 3 4 4 4",
    "C#m7": "C#m7 base-fret 0 frets x 4 2 4 2 4",
    "C#m7(b5)": "C#m7(b5) base-fret 0 frets x 4 2 4 2 3",
    "C#m9": "C#m9 base-fret 0 frets x 4 2 4 4 4",
    "C/A": "C/A base-fret 0 frets x 0 2 0 1 0",
    "C/B": "C/B base-fret 0 frets x 2 x 0 1 3",
    "C/A#": "C/A# base-fret 0 frets x 1 2 0 2 0",
    "C/D": "C/D base-fret 0 frets x x 0 0 1 0",
    "C/E": "C/E base-fret 0 frets 0 3 2 0 1 0",
    "C/F": "C/F base-fret 0 frets x x 3 0 1 0",
    "C/G": "C/G base-fret 0 frets 3 3 2 0 1 0",
    "C11": "C11 base-fret 0 frets x 3 3 3 3 3",
    "C2": "C2 base-fret 0 frets x 3 2 0 3 3",
    "C2/A": "C2/A base-fret 0 frets x 0 2 0 3 3",
    "C2/B": "C2/B base-fret 0 frets x 2 2 0 3 3",
    "C2/E": "C2/E base-fret 0 frets 0 3 2 0 3 3",
    "C2/G": "C2/G base-fret 0 frets 3 3 2 0 3 3",
    "Csus": "Csus base-fret 0 frets x 3 3 2 1 1",
    "C5": "C5 base-fret 0 frets x 3 x 0 1 3",
    "C5/B": "C5/B base-fret 0 frets x 2 x 0 1 3",
    "C5/G": "C5/G base-fret 0 frets 3 3 x 0 1 3",
    "C6": "C6 base-fret 0 frets x 3 2 2 1 0",
    "C7": "C7 base-fret 0 frets 0 3 2 3 1 0",
    "Caug7": "Caug7 base-fret 0 frets x 3 2 1 1 0",
    "C7(b9)": "C7(b9) base-fret 0 frets x 3 2 3 2 x",
    "C7/E": "C7/E base-fret 0 frets 0 3 2 3 1 0",
    "C7/G": "C7/G base-fret 0 frets 3 x 2 3 1 0",
    "C7sus4": "C7sus4 base-fret 0 frets x 3 3 3 1 3",
    "C9": "C9 base-fret 0 frets x 3 2 0 3 0",
    "Caug": "Caug base-fret 0 frets x 3 2 1 1 0",
    "Cdim": "Cdim base-fret 0 frets x x 1 2 1 2",
    "Cdim7": "Cdim7 base-fret 0 frets x 3 4 2 4 x",
    "Cm": "Cm base-fret 0 frets x 3 1 x 1 3",
    "Cm/D#": "Cm/D# base-fret 0 frets x x 1 x 1 3",
    "Cm11": "Cm11 base-fret 0 frets x 3 3 3 4 3",
    "Cm7": "Cm7 base-fret 0 frets x 3 1 3 4 x",
    "Cm9": "Cm9 base-fret 0 frets x 3 1 3 3 3",
    "Cma7": "Cma7 base-fret 0 frets x 3 2 0 0 0",
    "Cma9": "Cma9 base-fret 0 frets x 3 2 4 3 x",
    "D": "D base-fret 0 frets x x 0 2 3 2",
    "D/A": "D/A base-fret 0 frets x 0 0 2 3 2",
    "D/B": "D/B base-fret 0 frets x 2 0 2 3 2",
    "D/C": "D/C base-fret 0 frets x 3 x 2 3 2",
    "D/C#": "D/C# base-fret 0 frets x 4 x 2 3 2",
    "D/E": "D/E base-fret 0 frets x x 2 2 3 2",
    "D/F#": "D/F# base-fret 0 frets 2 0 0 2 3 2",
    "D/G": "D/G base-fret 0 frets 3 x 0 0 3 2",
    "D11": "D11 base-fret 3 frets x 2 2 2 2 2",
    "D13": "D13 base-fret 0 frets x x 0 2 0 2",
    "D2": "D2 base-fret 0 frets x x 0 2 2 0",
    "D2/A": "D2/A base-fret 0 frets x 0 0 2 3 0",
    "D2/B": "D2/B base-fret 0 frets x 2 0 2 3 0",
    "D2/C#": "D2/C# base-fret 0 frets x 4 0 2 3 0",
    "D2/F#": "D2/F# base-fret 0 frets 2 x 0 2 3 0",
    "Dsus": "Dsus base-fret 0 frets x x 0 2 3 3",
    "Dsus/A": "Dsus/A base-fret 0 frets x 0 0 2 3 3",
    "D5": "D5 base-fret 0 frets x x 0 2 3 x",
    "D5/A": "D5/A base-fret 2 frets x 0 0 1 2 4",
    "D5/C#": "D5/C# base-fret 2 frets x x 0 1 1 4",
    "D6": "D6 base-fret 0 frets x x 0 2 0 2",
    "D7": "D7 base-fret 0 frets x x 0 2 1 2",
    "Daug7": "Daug7 base-fret 0 frets x x 0 3 3 2",
    "D7(#9)": "D7(#9) base-fret 3 frets x 2 1 2 3 x",
    "D7(b5)": "D7(b5) base-fret 0 frets x x 0 1 1 2",
    "D7(b9)": "D7(b9) base-fret 2 frets x 4 x 4 3 1",
    "D7/A": "D7/A base-fret 0 frets x 0 0 2 1 2",
    "D7/C": "D7/C base-fret 0 frets x 3 0 2 1 2",
    "D7/F#": "D7/F# base-fret 0 frets 2 0 0 2 1 2",
    "D7sus4": "D7sus4 base-fret 0 frets x x 0 2 1 1",
    "D9": "D9 base-fret 0 frets x x 0 2 2 0",
    "Daug": "Daug base-fret 0 frets x x 0 3 3 2",
    "Ddim": "Ddim base-fret 0 frets x x 0 1 0 1",
    "Ddim7": "Ddim7 base-fret 0 frets x x 0 1 0 1",
    "Dm": "Dm base-fret 0 frets x x 0 2 1 3",
    "Dm/F": "Dm/F base-fret 0 frets x x 3 2 1 3",
    "Dm7": "Dm7 base-fret 0 frets x x 0 2 1 1",
    "Dm7(b5)": "Dm7(b5) base-fret 0 frets x x 0 1 1 1",
    "Dm7/C": "Dm7/C base-fret 0 frets x 3 x 2 1 1",
    "Dma7": "Dma7 base-fret 0 frets x x 0 2 2 2",
    "Dma9": "Dma9 base-fret 2 frets x 4 3 1 1 0",
    "E": "E base-fret 0 frets 0 2 2 1 0 0",
    "E/A": "E/A base-fret 0 frets x 0 2 1 0 0",
    "E/B": "E/B base-fret 0 frets x 2 2 1 0 0",
    "E/C#": "E/C# base-fret 0 frets x 4 2 4 0 0",
    "E/D": "E/D base-fret 0 frets x x 0 1 0 0",
    "E/D#": "E/D# base-fret 0 frets x x 1 1 0 0",
    "E/F#": "E/F# base-fret 0 frets 2 2 2 1 0 x",
    "E/G#": "E/G# base-fret 0 frets 4 x 2 4 0 0",
    "E11": "E11 base-fret 0 frets 0 2 0 2 3 4",
    "E13": "E13 base-fret 0 frets 0 2 0 1 3 0",
    "E2": "E2 base-fret 0 frets 0 2 4 1 0 0",
    "E2/B": "E2/B base-fret 0 frets x 2 4 1 0 0",
    "E2/C#": "E2/C# base-fret 5 frets x 2 4 4 0 0",
    "E2/D#": "E2/D# base-fret 5 frets x 2 4 3 0 0",
    "E2/G#": "E2/G# base-fret 0 frets 4 x 4 4 0 0",
    "Esus": "Esus base-fret 0 frets 0 2 2 2 0 0",
    "Esus/B": "Esus/B base-fret 0 frets x 2 2 2 0 0",
    "E5": "E5 base-fret 0 frets 0 2 4 4 0 0",
    "E5/B": "E5/B base-fret 0 frets x 2 2 4 0 0",
    "E5/D#": "E5/D# base-fret 5 frets x 1 4 3 0 0",
    "E6": "E6 base-fret 0 frets 0 2 2 1 2 0",
    "E7": "E7 base-fret 0 frets 0 2 0 1 0 0",
    "E7(#9)": "E7(#9) base-fret 0 frets 0 2 0 1 3 3",
    "E7(b5)": "E7(b5) base-fret 0 frets 0 1 2 1 3 x",
    "E7(b9)": "E7(b9) base-fret 0 frets 0 x 0 1 0 1",
    "E7/B": "E7/B base-fret 0 frets x 2 0 1 0 0",
    "E7/D": "E7/D base-fret 0 frets x x 0 1 0 0",
    "E7/G#": "E7/G# base-fret 0 frets 4 x 0 4 0 0",
    "E7sus4": "E7sus4 base-fret 0 frets 0 2 0 2 0 0",
    "E9": "E9 base-fret 0 frets 0 2 4 1 0 0",
    "Eaug": "Eaug base-fret 0 frets 0 3 2 1 1 0",
    "Eaug7": "Eaug7 base-fret 0 frets 0 3 2 1 1 0",
    "D#/A#": "D#/A# base-fret 0 frets x x x 3 4 3",
    "D#11": "D#11 base-fret 0 frets x x 1 0 2 4",
    "D#13": "D#13 base-fret 4 frets x 2 1 2 2 4",
    "D#2": "D#2 base-fret 0 frets x x 1 3 4 1",
    "D#2/A#": "D#2/A# base-fret 5 frets 1 1 3 3 1 1",
    "D#7": "D#7 base-fret 0 frets x x 1 3 2 3",
    "D#aug7": "D#aug7 base-fret 0 frets x x 1 4 2 3",
    "D#7(#9)": "D#7(#9) base-fret 0 frets x x 1 0 2 2",
    "D#7(b5)": "D#7(b5) base-fret 0 frets x x 1 2 2 3",
    "D#7(b9)": "D#7(b9) base-fret 0 frets x x 1 0 2 0",
    "D#7/A#": "D#7/A# base-fret 5 frets 2 2 4 2 4 2",
    "D#9": "D#9 base-fret 0 frets x x 1 0 2 1",
    "D#dim7": "D#dim7 base-fret 0 frets x x 1 2 1 2",
    "D#m9": "D#m9 base-fret 3 frets x 3 1 3 3 3",
    "D#ma9": "D#ma9 base-fret 0 frets x x 1 0 3 1",
    "Edim": "Edim base-fret 0 frets 0 1 2 0 2 0",
    "Edim7": "Edim7 base-fret 0 frets 0 1 2 0 2 0",
    "Em": "Em base-fret 0 frets 0 2 2 0 0 0",
    "Em/G": "Em/G base-fret 0 frets 3 2 2 0 3 3",
    "Em7": "Em7 base-fret 0 frets 0 2 2 0 3 0",
    "Em7/D": "Em7/D base-fret 0 frets x x 0 0 3 3",
    "Em9": "Em9 base-fret 0 frets 0 2 4 0 0 0",
    "Ema7": "Ema7 base-fret 0 frets 0 2 1 1 0 0",
    "Ema9": "Ema9 base-fret 0 frets 0 2 4 4 4 4",
    "F": "F base-fret 0 frets x x 3 2 1 1",
    "F#/C#": "F#/C# base-fret 0 frets x 4 4 3 2 2",
    "F#13": "F#13 base-fret 0 frets 2 4 2 3 4 2",
    "F#sus": "F#sus base-fret 0 frets 2 4 4 4 2 2",
    "F#6": "F#6 base-fret 0 frets 2 x 1 3 2 x",
    "F#7": "F#7 base-fret 0 frets 1 4 1 3 1 1",
    "F#7(b5)": "F#7(b5) base-fret 0 frets 2 x 2 3 1 x",
    "F#7/C#": "F#7/C# base-fret 0 frets x 4 2 3 2 2",
    "F#dim7": "F#dim7 base-fret 0 frets 2 3 4 2 4 2",
    "F#m/A": "F#m/A base-fret 0 frets x 0 2 2 0 0",
    "F#m6": "F#m6 base-fret 0 frets 2 x 1 2 2 2",
    "F#m7": "F#m7 base-fret 0 frets 2 x 2 2 0 0",
    "F#m7(b5)": "F#m7(b5) base-fret 0 frets 2 x 2 2 1 0",
    "F#m7/E": "F#m7/E base-fret 0 frets 0 4 4 2 0 0",
    "F#ma9": "F#ma9 base-fret 0 frets 2 1 3 1 2 1",
    "F/A": "F/A base-fret 0 frets x 0 3 2 1 1",
    "F/A#": "F/A# base-fret 0 frets x 1 3 2 1 1",
    "F/C": "F/C base-fret 0 frets x 3 3 2 1 1",
    "F/D": "F/D base-fret 0 frets x x 0 2 1 1",
    "F/E": "F/E base-fret 0 frets x x 2 2 1 1",
    "F/D#": "F/D# base-fret 0 frets x x 1 2 1 1",
    "F/G": "F/G base-fret 0 frets 3 x 3 2 1 1",
    "F13": "F13 base-fret 0 frets 1 3 1 2 3 1",
    "F2": "F2 base-fret 0 frets x x 3 0 1 1",
    "F2/A": "F2/A base-fret 0 frets x 0 3 0 1 1",
    "F2/C": "F2/C base-fret 0 frets x 3 3 0 1 1",
    "F2/D": "F2/D base-fret 0 frets x x 0 0 1 1",
    "F2/E": "F2/E base-fret 0 frets x x 2 0 1 1",
    "Fsus": "Fsus base-fret 0 frets x x 3 3 1 1",
    "F5": "F5 base-fret 0 frets 1 3 3 x 1 1",
    "F6": "F6 base-fret 0 frets x x 3 2 3 1",
    "F7": "F7 base-fret 0 frets 1 3 1 2 1 1",
    "F7(#9)": "F7(#9) base-fret 0 frets x x 3 2 4 4",
    "F7(b9)": "F7(b9) base-fret 0 frets x x 3 2 4 2",
    "F7/A": "F7/A base-fret 0 frets x 0 1 2 1 1",
    "F7/C": "F7/C base-fret 0 frets x 3 1 2 1 1",
    "F7sus4": "F7sus4 base-fret 0 frets 1 3 1 3 1 1",
    "F9": "F9 base-fret 0 frets x x 3 0 1 1",
    "Faug": "Faug base-fret 0 frets x x 3 2 2 1",
    "Faug7": "Faug7 base-fret 0 frets x x 3 2 2 1",
    "Fdim": "Fdim base-fret 0 frets x x 0 1 0 1",
    "Fdim7": "Fdim7 base-fret 0 frets x x 3 4 3 4",
    "Fm": "Fm base-fret 0 frets x x 3 1 1 1",
    "Fm6": "Fm6 base-fret 0 frets 1 x 0 1 1 1",
    "Fm7": "Fm7 base-fret 0 frets 1 3 1 1 1 1",
    "Fm7(b5)": "Fm7(b5) base-fret 0 frets 1 x 1 1 0 x",
    "Fm9": "Fm9 base-fret 0 frets 1 3 1 1 1 3",
    "Fma7": "Fma7 base-fret 0 frets x x 3 2 1 0",
    "G": "G base-fret 0 frets 3 2 0 0 3 3",
    "G#/D#": "G#/D# base-fret 0 frets x x 1 1 1 4",
    "G#11": "G#11 base-fret 0 frets 4 x 4 3 2 x",
    "G#13": "G#13 base-fret 0 frets 4 x 4 3 1 1",
    "G#13(b9)": "G#13(b9) base-fret 3 frets 1 x 1 2 3 2",
    "G#7": "G#7 base-fret 0 frets 4 3 4 1 1 x",
    "G#aug7": "G#aug7 base-fret 0 frets 4 x 3 4 4 4",
    "G#7(#5b9)": "G#7(#5b9) base-fret 3 frets 1 x 1 2 2 2",
    "G#7(#9)": "G#7(#9) base-fret 0 frets 4 x 4 2 4 x",
    "G#7(b5)": "G#7(b5) base-fret 0 frets 4 3 4 x 3 4",
    "G#7/D#": "G#7/D# base-fret 3 frets x 3 1 2 1 1",
    "G#9(b5)": "G#9(b5) base-fret 0 frets 4 x 4 3 3 x",
    "G#m11": "G#m11 base-fret 0 frets 4 x 4 4 2 x",
    "G#m13": "G#m13 base-fret 0 frets 4 2 4 x x 1",
    "G#m6": "G#m6 base-fret 0 frets 4 3 4 3 4 4",
    "G#m7": "G#m7 base-fret 0 frets 4 2 4 4 x 2",
    "G#m7(b5)": "G#m7(b5) base-fret 0 frets 4 x 4 4 3 x",
    "G#m7(b9)": "G#m7(b9) base-fret 2 frets 2 x 1 2 2 4",
    "G#m9": "G#m9 base-fret 0 frets 4 2 4 3 x 2",
    "G/A": "G/A base-fret 0 frets x 0 0 0 3 3",
    "G/B": "G/B base-fret 0 frets x 2 0 0 3 3",
    "G/C": "G/C base-fret 0 frets x 3 0 0 3 3",
    "G/D": "G/D base-fret 0 frets x x 0 0 3 3",
    "G/E": "G/E base-fret 0 frets 0 2 0 0 3 3",
    "G/F": "G/F base-fret 0 frets 1 2 0 0 3 3",
    "G/F#": "G/F# base-fret 0 frets 2 2 0 0 3 3",
    "G11": "G11 base-fret 0 frets 3 x 3 2 1 x",
    "G13": "G13 base-fret 0 frets 3 2 3 0 0 0",
    "G13(b9)": "G13(b9) base-fret 3 frets 1 x 1 2 3 2",
    "G2": "G2 base-fret 0 frets 3 x 0 2 3 3",
    "G2/B": "G2/B base-fret 0 frets x 2 0 2 3 3",
    "G2/D": "G2/D base-fret 0 frets x x 0 2 3 3",
    "G2/E": "G2/E base-fret 0 frets x x 2 2 3 3",
    "G2/F#": "G2/F# base-fret 0 frets 2 x 0 2 3 3",
    "Gsus": "Gsus base-fret 0 frets 3 x 0 0 1 3",
    "Gsus/D": "Gsus/D base-fret 0 frets x x 0 0 1 3",
    "G5": "G5 base-fret 0 frets 3 x 0 0 3 3",
    "G5/D": "G5/D base-fret 0 frets x x 0 0 3 3",
    "G5/F#": "G5/F# base-fret 0 frets 2 x 0 0 3 3",
    "G6": "G6 base-fret 0 frets 3 2 0 0 0 0",
    "G7": "G7 base-fret 0 frets 3 2 3 0 0 3",
    "Gaug7": "Gaug7 base-fret 0 frets 3 x 3 4 2 x",
    "G7(#5b9)": "G7(#5b9) base-fret 0 frets 3 x 3 4 4 4",
    "G7(#9)": "G7(#9) base-fret 0 frets 3 2 3 3 3 x",
    "G7(b5)": "G7(b5) base-fret 0 frets 3 x 3 4 4 x",
    "G7(b9)": "G7(b9) base-fret 0 frets 3 x 3 1 3 x",
    "G7/B": "G7/B base-fret 0 frets x 2 3 0 3 3",
    "G7/D": "G7/D base-fret 0 frets x x 0 0 0 1",
    "G7sus4": "G7sus4 base-fret 0 frets 3 x 0 0 1 1",
    "G9": "G9 base-fret 0 frets 3 x 0 2 3 3",
    "G9(b5)": "G9(b5) base-fret 0 frets 3 x 3 2 2 x",
    "Gaug": "Gaug base-fret 0 frets 3 2 1 0 0 3",
    "F#9": "F#9 base-fret 0 frets 2 4 2 3 2 4",
    "Gdim": "Gdim base-fret 0 frets x 1 2 0 2 0",
    "Gdim7": "Gdim7 base-fret 0 frets x 1 2 0 2 0",
    "Gm11": "Gm11 base-fret 0 frets 3 x 3 3 1 x",
    "Gm6": "Gm6 base-fret 0 frets 3 x 2 3 3 3",
    "Gm7(b5)": "Gm7(b5) base-fret 0 frets 3 x 3 3 2 x",
    "Gma7": "Gma7 base-fret 0 frets 3 x 3 0 0 2",
    "Gma9": "Gma9 base-fret 0 frets 3 x 4 2 3 x",
    "A9(#5)": "A9(#5) base-fret 0 frets x 0 3 4 2 3",
    "A9sus4": "A9sus4 base-fret 0 frets x 0 0 0 0 0",
    "G#": "G# base-fret 0 frets 4 3 1 1 1 x",
    "G#(2)": "G#(2) base-fret 0 frets 4 1 1 3 1 4",
    "G#6": "G#6 base-fret 0 frets 4 3 1 1 1 1",
    "G#6/9": "G#6/9 base-fret 0 frets 4 3 3 3 4 x",
    "G#7(b9)": "G#7(b9) base-fret 0 frets x x 1 2 1 2",
    "G#7sus4": "G#7sus4 base-fret 0 frets x x 1 1 2 2",
    "G#9(#5)": "G#9(#5) base-fret 0 frets 4 3 2 3 x 2",
    "G#9sus4": "G#9sus4 base-fret 0 frets 4 x 4 3 2 2",
    "G#dim7": "G#dim7 base-fret 0 frets x x 0 1 0 1",
    "G#m": "G#m base-fret 0 frets 4 2 1 1 4 x",
    "G#m(ma7)": "G#m(ma7) base-fret 0 frets 4 2 1 1 x 3",
    "G#ma7": "G#ma7 base-fret 0 frets 4 3 1 1 1 3",
    "G#ma7(#11)": "G#ma7(#11) base-fret 3 frets 2 x 3 3 1 x",
    "G#2": "G#2 base-fret 0 frets 4 1 1 1 4 x",
    "Am11": "Am11 base-fret 0 frets x 0 0 0 1 0",
    "Ama7(#11)": "Ama7(#11) base-fret 0 frets x 0 1 1 2 x",
    "B(2)": "B(2) base-fret 0 frets x 2 1 x 2 2",
    "B9(#5)": "B9(#5) base-fret 0 frets x 2 1 2 2 3",
    "B9sus4": "B9sus4 base-fret 0 frets x 2 2 2 2 2",
    "A#(2)": "A#(2) base-fret 0 frets x 1 0 3 1 x",
    "A#5": "A#5 base-fret 0 frets x 1 3 3 x x",
    "A#6": "A#6 base-fret 0 frets x 1 3 3 3 3",
    "A#6/9": "A#6/9 base-fret 0 frets x 1 0 0 1 1",
    "A#7(b9)": "A#7(b9) base-fret 0 frets x 1 0 1 0 1",
    "A#7sus4": "A#7sus4 base-fret 0 frets x 1 3 1 4 1",
    "A#9(#5)": "A#9(#5) base-fret 0 frets x x 0 1 1 2",
    "A#9sus4": "A#9sus4 base-fret 0 frets x 1 1 1 1 1",
    "A#dim7": "A#dim7 base-fret 0 frets x x 2 3 2 3",
    "A#m": "A#m base-fret 0 frets x 1 3 0 2 x",
    "A#m(ma7)": "A#m(ma7) base-fret 0 frets x 1 3 2 2 1",
    "A#ma7": "A#ma7 base-fret 0 frets x 1 3 2 3 1",
    "A#ma7(#11)": "A#ma7(#11) base-fret 0 frets x 1 2 2 3 0",
    "Bm(ma7)": "Bm(ma7) base-fret 0 frets x 2 0 3 3 2",
    "Bma7(#11)": "Bma7(#11) base-fret 0 frets x 2 3 3 4 x",
    "C(2)": "C(2) base-fret 0 frets x 3 2 0 3 0",
    "C#5": "C#5 base-fret 0 frets x x x x 2 4",
    "C13": "C13 base-fret 2 frets x 2 1 2 2 4",
    "C6/9": "C6/9 base-fret 0 frets x 3 2 2 3 x",
    "C7(#9)": "C7(#9) base-fret 0 frets x 3 2 3 4 x",
    "C7(b5)": "C7(b5) base-fret 0 frets x 3 2 3 x 2",
    "C9(#5)": "C9(#5) base-fret 0 frets x 3 2 3 3 4",
    "C9(b5)": "C9(b5) base-fret 0 frets x 3 2 3 3 2",
    "C9sus4": "C9sus4 base-fret 0 frets x 3 3 3 3 3",
    "Cm(ma7)": "Cm(ma7) base-fret 0 frets x 3 1 0 0 3",
    "Cm13": "Cm13 base-fret 3 frets x 1 1 1 2 3",
    "Cm6": "Cm6 base-fret 0 frets x 3 1 2 1 x",
    "Cm7(b5)": "Cm7(b5) base-fret 0 frets x 3 4 3 4 x",
    "Cma7(#11)": "Cma7(#11) base-fret 3 frets x 1 2 2 3 x",
    "D(2)": "D(2) base-fret 2 frets x 4 3 1 4 0",
    "D6/9": "D6/9 base-fret 2 frets x 4 x 3 4 1",
    "D9(#5)": "D9(#5) base-fret 3 frets x 3 2 3 3 4",
    "D9(b5)": "D9(b5) base-fret 3 frets x 3 2 3 3 2",
    "D9sus4": "D9sus4 base-fret 0 frets x x 0 0 1 0",
    "C#": "C# base-fret 0 frets x 4 3 1 2 1",
    "C#(2)": "C#(2) base-fret 0 frets x 4 3 1 4 x",
    "C#6": "C#6 base-fret 0 frets x 4 3 3 2 x",
    "C#6/9": "C#6/9 base-fret 0 frets x 4 3 3 4 4",
    "C#7(#9)": "C#7(#9) base-fret 0 frets x 4 3 4 0 0",
    "C#7sus4": "C#7sus4 base-fret 0 frets x 4 4 4 2 x",
    "C#9(#5)": "C#9(#5) base-fret 3 frets x 2 1 2 2 3",
    "C#9(b5)": "C#9(b5) base-fret 0 frets x 4 3 4 4 3",
    "C#9sus4": "C#9sus4 base-fret 0 frets x 4 4 4 4 4",
    "C#dim7": "C#dim7 base-fret 0 frets x x 2 3 2 3",
    "C#m": "C#m base-fret 0 frets x 4 2 x 2 4",
    "C#m(ma7)": "C#m(ma7) base-fret 0 frets x 4 2 1 1 4",
    "C#m11": "C#m11 base-fret 0 frets x 4 2 4 4 2",
    "C#m13": "C#m13 base-fret 3 frets x 2 2 2 3 4",
    "C#m6": "C#m6 base-fret 0 frets x 4 2 3 2 x",
    "C#ma7": "C#ma7 base-fret 0 frets x 4 3 1 1 1",
    "C#ma7(#11)": "C#ma7(#11) base-fret 3 frets x 2 3 3 4 x",
    "C#ma9": "C#ma9 base-fret 3 frets x 2 1 4 3 x",
    "C#sus": "C#sus base-fret 0 frets x 4 4 1 2 x",
    "Dm9": "Dm9 base-fret 2 frets x 4 2 1 4 0",
    "Dm(ma7)": "Dm(ma7) base-fret 0 frets x x 0 2 2 1",
    "Dm11": "Dm11 base-fret 3 frets x 3 1 3 3 1",
    "Dm13": "Dm13 base-fret 5 frets x 1 1 1 2 3",
    "Dm6": "Dm6 base-fret 0 frets x x 0 2 0 1",
    "Dma7(#11)": "Dma7(#11) base-fret 5 frets x 1 2 2 3 x",
    "E(2)": "E(2) base-fret 0 frets 0 2 2 1 0 2",
    "E6/9": "E6/9 base-fret 0 frets 0 x 2 1 2 2",
    "E9(#5)": "E9(#5) base-fret 0 frets 0 x 0 1 1 2",
    "E9(b5)": "E9(b5) base-fret 0 frets 0 1 2 1 3 2",
    "E9sus4": "E9sus4 base-fret 0 frets 0 2 0 2 0 2",
    "D#": "D# base-fret 0 frets x x 1 3 4 3",
    "D#aug": "D#aug base-fret 0 frets x x 1 0 0 x",
    "D#(2)": "D#(2) base-fret 3 frets x 4 3 1 4 x",
    "D#(b5)": "D#(b5) base-fret 5 frets x 2 1 2 2 1",
    "D#5": "D#5 base-fret 0 frets x x 1 3 4 x",
    "D#6": "D#6 base-fret 0 frets x x 1 3 1 3",
    "D#6/9": "D#6/9 base-fret 0 frets x x 1 0 1 1",
    "D#7sus4": "D#7sus4 base-fret 0 frets x x 1 1 2 4",
    "D#9sus4": "D#9sus4 base-fret 0 frets x x 1 1 2 1",
    "D#m": "D#m base-fret 0 frets x x 1 3 4 2",
    "D#m(ma7)": "D#m(ma7) base-fret 0 frets x x 1 3 3 2",
    "D#m11": "D#m11 base-fret 3 frets x 4 2 4 4 2",
    "D#m13": "D#m13 base-fret 5 frets x 2 2 2 3 4",
    "D#m7": "D#m7 base-fret 0 frets x x 1 3 2 2",
    "D#m7(b5)": "D#m7(b5) base-fret 0 frets x x 1 2 2 2",
    "D#ma7": "D#ma7 base-fret 0 frets x x 1 3 3 3",
    "D#ma7(#11)": "D#ma7(#11) base-fret 5 frets x 2 3 3 4 x",
    "D#sus": "D#sus base-fret 0 frets x 1 1 3 4 4",
    "Em(ma7)": "Em(ma7) base-fret 0 frets 0 2 1 0 0 0",
    "Em11": "Em11 base-fret 0 frets 0 2 0 2 0 3",
    "Em13": "Em13 base-fret 0 frets 0 4 4 0 2 0",
    "Em6": "Em6 base-fret 0 frets 0 2 2 0 2 0",
    "Em7(b5)": "Em7(b5) base-fret 0 frets 0 x 2 3 3 3",
    "Ema7(#11)": "Ema7(#11) base-fret 0 frets 0 x 2 3 4 4",
    "F(2)": "F(2) base-fret 0 frets x x 3 2 1 3",
    "F#": "F# base-fret 0 frets 3 x 2 4 3 x",
    "F#(2)": "F#(2) base-fret 0 frets 2 x 4 3 2 4",
    "F#5": "F#5 base-fret 0 frets 2 4 4 x x x",
    "F#6/9": "F#6/9 base-fret 0 frets 2 1 1 1 2 x",
    "F#aug7": "F#aug7 base-fret 0 frets 2 x 2 3 3 x",
    "F#7(#9)": "F#7(#9) base-fret 0 frets 2 1 2 2 x x",
    "F#7(b9)": "F#7(b9) base-fret 0 frets x x 2 3 2 3",
    "F#7sus4": "F#7sus4 base-fret 0 frets 1 4 2 4 2 2",
    "F#9(#5)": "F#9(#5) base-fret 0 frets 2 1 2 1 3 x",
    "F#9(b5)": "F#9(b5) base-fret 0 frets 2 1 2 1 3 x",
    "F#9sus4": "F#9sus4 base-fret 0 frets 2 4 2 4 2 4",
    "F#m": "F#m base-fret 0 frets 2 4 4 2 2 2",
    "F#m9": "F#m9 base-fret 0 frets 2 4 4 2 2 4",
    "F#m(ma7)": "F#m(ma7) base-fret 0 frets 2 4 3 2 2 x",
    "F#m11": "F#m11 base-fret 0 frets 2 x 2 2 0 0",
    "F#m13": "F#m13 base-fret 0 frets 1 3 1 1 3 1",
    "F#ma7": "F#ma7 base-fret 0 frets 2 x 3 3 2 x",
    "F#ma7(#11)": "F#ma7(#11) base-fret 0 frets 2 x 3 3 1 x",
    "F#2": "F#2 base-fret 0 frets 2 4 4 x 2 4",
    "F6/9": "F6/9 base-fret 0 frets 1 0 0 0 1 1",
    "F7(b5)": "F7(b5) base-fret 0 frets 1 0 1 2 0 x",
    "F9(#5)": "F9(#5) base-fret 0 frets 1 0 1 0 2 x",
    "F9(b5)": "F9(b5) base-fret 0 frets 1 0 1 0 0 x",
    "F9sus4": "F9sus4 base-fret 0 frets 1 3 1 3 1 3",
    "Fm(ma7)": "Fm(ma7) base-fret 0 frets 1 x x 1 1 0",
    "Fm11": "Fm11 base-fret 0 frets 1 3 1 3 1 4",
    "Fm13": "Fm13 base-fret 0 frets 1 3 1 1 3 1",
    "Fma7(#11)": "Fma7(#11) base-fret 0 frets 1 x 2 2 0 0",
    "Fma9": "Fma9 base-fret 0 frets 1 0 2 0 1 0",
    "G(2)": "G(2) base-fret 0 frets 3 x 0 2 0 3",
    "G#5": "G#5 base-fret 0 frets 4 x 1 1 4 x",
    "G6/9": "G6/9 base-fret 0 frets 3 2 2 2 3 0",
    "G9(#5)": "G9(#5) base-fret 0 frets 3 2 3 2 4 x",
    "G9sus4": "G9sus4 base-fret 0 frets 3 x 3 2 1 1",
    "Gm": "Gm base-fret 0 frets 3 x 0 3 3 3",
    "Gm9": "Gm9 base-fret 0 frets 3 1 3 2 x 1",
    "Gm(ma7)": "Gm(ma7) base-fret 0 frets 3 x 0 3 3 2",
    "Gm13": "Gm13 base-fret 0 frets 3 x 3 3 1 0",
    "Gm7": "Gm7 base-fret 0 frets 3 x 3 3 3 x",
    "Gma7(#11)": "Gma7(#11) base-fret 0 frets 3 x 4 4 2 x",
    "A(2)": "A(2) base-fret 0 frets x 0 2 4 2 0",
    "A(4)": "A(4) base-fret 0 frets x 0 0 2 2 0",
    "Am2": "Am2 base-fret 0 frets x 0 2 4 1 0",
    "A6/9": "A6/9 base-fret 0 frets x 0 2 4 2 2",
    "A13sus4": "A13sus4 base-fret 0 frets x 0 0 0 0 2",
    "Am(ma7)": "Am(ma7) base-fret 0 frets x x x 2 1 4",
    "Am(ma9)": "Am(ma9) base-fret 2 frets x 0 1 4 0 3",
    "A7(#9)": "A7(#9) base-fret 2 frets 4 x 1 4 1 2",
    "Am7(#5)": "Am7(#5) base-fret 0 frets x 0 3 2 1 3",
    "Ama7(#5)": "Ama7(#5) base-fret 0 frets x 0 3 1 2 1",
    "Ama7(b5)": "Ama7(b5) base-fret 0 frets x 0 1 2 2 4",
    "A/A#": "A/A# base-fret 0 frets x 1 2 2 2 x",
    "A/C": "A/C base-fret 0 frets x 3 2 2 2 x",
    "A/D#": "A/D# base-fret 0 frets x x 1 2 2 0",
    "A/F": "A/F base-fret 0 frets 1 4 2 2 x x",
    "Am/A#": "Am/A# base-fret 0 frets x 1 2 2 1 x",
    "Am/B": "Am/B base-fret 0 frets x 2 2 2 1 x",
    "Am/C#": "Am/C# base-fret 0 frets x 4 2 2 1 x",
    "Am/D": "Am/D base-fret 0 frets x x 0 2 1 0",
    "Am/D#": "Am/D# base-fret 0 frets x x 1 2 1 0",
    "Am/E": "Am/E base-fret 0 frets x x 2 2 1 x",
    "Am/F": "Am/F base-fret 0 frets 1 3 2 2 x x",
    "Am/F#": "Am/F# base-fret 0 frets 2 3 2 2 x x",
    "Am/G": "Am/G base-fret 0 frets 3 3 2 2 x x",
    "Am/G#": "Am/G# base-fret 0 frets 4 3 2 2 x x",
    "A#": "A# base-fret 0 frets x 1 3 3 3 1",
    "A#(4)": "A#(4) base-fret 0 frets x 1 1 3 3 1",
    "A#m2": "A#m2 base-fret 3 frets 4 1 1 4 4 x",
    "A#aug": "A#aug base-fret 0 frets x x x 3 3 2",
    "A#dim": "A#dim base-fret 0 frets x 1 2 3 2 x",
    "A#13sus4": "A#13sus4 base-fret 0 frets x 1 1 1 4 3",
    "A#m(ma9)": "A#m(ma9) base-fret 3 frets 4 2 x 3 4 3",
    "A#m7(#5)": "A#m7(#5) base-fret 0 frets x 1 4 1 2 x",
    "A#ma7(#5)": "A#ma7(#5) base-fret 0 frets x 1 4 2 3 2",
    "A#ma7(b5)": "A#ma7(b5) base-fret 0 frets x 1 2 2 3 x",
    "A#/A": "A#/A base-fret 0 frets x 0 0 3 3 1",
    "A#/B": "A#/B base-fret 0 frets x 2 3 3 3 x",
    "A#/C": "A#/C base-fret 0 frets x 3 3 3 3 x",
    "A#/C#": "A#/C# base-fret 0 frets x 4 3 3 3 x",
    "A#/D#": "A#/D# base-fret 0 frets x x 1 3 3 1",
    "A#/E": "A#/E base-fret 0 frets 0 1 3 x 3 1",
    "A#/F#": "A#/F# base-fret 0 frets 2 1 3 x 3 1",
    "A#/G": "A#/G base-fret 0 frets 3 1 3 x 3 1",
    "A#/G#": "A#/G# base-fret 0 frets 4 1 3 x 3 1",
    "A#m/A": "A#m/A base-fret 0 frets x 0 3 3 2 1",
    "A#m/B": "A#m/B base-fret 0 frets x 2 3 3 2 x",
    "A#m/C": "A#m/C base-fret 0 frets x 3 3 3 2 x",
    "A#m/C#": "A#m/C# base-fret 0 frets x 4 3 3 x x",
    "A#m/D": "A#m/D base-fret 0 frets x x 0 3 2 1",
    "A#m/D#": "A#m/D# base-fret 0 frets x x 1 3 2 1",
    "A#m/E": "A#m/E base-fret 0 frets 0 1 3 3 2 1",
    "A#m/F": "A#m/F base-fret 0 frets 1 1 3 3 2 1",
    "A#m/F#": "A#m/F# base-fret 0 frets 2 1 x 3 2 1",
    "A#m/G": "A#m/G base-fret 0 frets 3 1 3 x 2 1",
    "A#m/G#": "A#m/G# base-fret 0 frets 4 1 3 x 2 1",
    "B(4)": "B(4) base-fret 0 frets x 2 2 4 4 2",
    "Bm2": "Bm2 base-fret 0 frets x 2 0 x 2 2",
    "B13sus4": "B13sus4 base-fret 0 frets x 2 2 2 0 4",
    "Bm(ma9)": "Bm(ma9) base-fret 0 frets x 2 0 3 2 x",
    "Bm7(#5)": "Bm7(#5) base-fret 0 frets x 2 x 2 3 3",
    "Bma7(#5)": "Bma7(#5) base-fret 0 frets x 2 1 3 4 3",
    "Bma7(b5)": "Bma7(b5) base-fret 0 frets x 2 1 3 4 1",
    "B/C": "B/C base-fret 0 frets x 3 4 4 4 x",
    "B/D": "B/D base-fret 0 frets x x 0 4 4 2",
    "B/F": "B/F base-fret 0 frets 1 2 1 x 4 2",
    "B/G": "B/G base-fret 0 frets 3 2 4 x 4 2",
    "Bm/A": "Bm/A base-fret 0 frets x 0 0 4 3 2",
    "Bm/A#": "Bm/A# base-fret 0 frets x 1 x 4 3 2",
    "Bm/C": "Bm/C base-fret 0 frets x 3 4 4 3 x",
    "Bm/C#": "Bm/C# base-fret 0 frets x 4 4 4 3 x",
    "Bm/D#": "Bm/D# base-fret 0 frets x x 1 4 3 2",
    "Bm/E": "Bm/E base-fret 0 frets 0 2 0 4 3 2",
    "Bm/F": "Bm/F base-fret 0 frets x x 3 4 3 2",
    "Bm/F#": "Bm/F# base-fret 0 frets 2 2 4 4 3 2",
    "Bm/G": "Bm/G base-fret 0 frets 3 2 x 4 3 2",
    "Bm/G#": "Bm/G# base-fret 0 frets 4 2 4 x 3 2",
    "C(4)": "C(4) base-fret 0 frets x 3 2 0 1 1",
    "Cm2": "Cm2 base-fret 0 frets x 3 1 x 3 3",
    "C13sus4": "C13sus4 base-fret 3 frets x 1 1 1 4 3",
    "Cm(ma9)": "Cm(ma9) base-fret 0 frets x 3 1 4 3 3",
    "Cm7(#5)": "Cm7(#5) base-fret 0 frets x 3 1 3 1 4",
    "Cma7(#5)": "Cma7(#5) base-fret 0 frets x 3 2 4 x 4",
    "Cma7(b5)": "Cma7(b5) base-fret 0 frets x 3 2 4 x 2",
    "C/C#": "C/C# base-fret 0 frets x 4 2 x 1 3",
    "C/D#": "C/D# base-fret 0 frets x x 1 0 1 0",
    "C/F#": "C/F# base-fret 0 frets 2 3 2 x x 3",
    "C/G#": "C/G# base-fret 0 frets 4 3 2 0 x 0",
    "Cm/A": "Cm/A base-fret 0 frets x 0 1 0 1 3",
    "Cm/A#": "Cm/A# base-fret 0 frets x 1 1 x 1 3",
    "Cm/B": "Cm/B base-fret 0 frets x 2 1 x 1 3",
    "Cm/C#": "Cm/C# base-fret 0 frets x 4 1 0 1 x",
    "Cm/D": "Cm/D base-fret 3 frets x 3 3 3 2 x",
    "Cm/E": "Cm/E base-fret 0 frets 0 3 1 0 1 x",
    "Cm/F": "Cm/F base-fret 0 frets 1 3 1 0 x x",
    "Cm/F#": "Cm/F# base-fret 0 frets 2 3 1 x x 3",
    "Cm/G": "Cm/G base-fret 0 frets 3 3 1 x x x",
    "Cm/G#": "Cm/G# base-fret 0 frets 4 3 x x 4 3",
    "C#(4)": "C#(4) base-fret 0 frets x 4 4 1 2 1",
    "C#m2": "C#m2 base-fret 0 frets x 4 2 1 4 4",
    "C#aug": "C#aug base-fret 0 frets x 4 3 2 2 x",
    "C#dim": "C#dim base-fret 0 frets x 4 2 x 2 3",
    "C#13sus4": "C#13sus4 base-fret 3 frets x 2 2 2 0 4",
    "C#m(ma9)": "C#m(ma9) base-fret 2 frets x 3 1 4 3 3",
    "C#m7(#5)": "C#m7(#5) base-fret 0 frets x 4 2 2 0 0",
    "C#ma7(#5)": "C#ma7(#5) base-fret 0 frets x 4 3 2 1 1",
    "C#ma7(b5)": "C#ma7(b5) base-fret 0 frets x 4 3 x 1 3",
    "C#/A": "C#/A base-fret 0 frets x 0 3 1 2 1",
    "C#/A#": "C#/A# base-fret 0 frets x 1 3 1 2 1",
    "C#/B": "C#/B base-fret 0 frets x 2 3 1 2 1",
    "C#/C": "C#/C base-fret 0 frets x 3 3 1 2 1",
    "C#/D": "C#/D base-fret 0 frets x x 0 1 2 1",
    "C#/D#": "C#/D# base-fret 0 frets x x 1 1 2 1",
    "C#/E": "C#/E base-fret 0 frets 0 4 3 1 2 1",
    "C#/F": "C#/F base-fret 0 frets x x 3 1 2 1",
    "C#/F#": "C#/F# base-fret 0 frets x x 4 1 2 1",
    "C#/G": "C#/G base-fret 0 frets 3 x 3 1 2 1",
    "C#m/A": "C#m/A base-fret 0 frets x 0 2 1 2 0",
    "C#m/A#": "C#m/A# base-fret 0 frets x 1 2 1 2 x",
    "C#m/B": "C#m/B base-fret 0 frets x 2 2 1 2 x",
    "C#m/C": "C#m/C base-fret 0 frets x 3 2 1 2 x",
    "C#m/D": "C#m/D base-fret 0 frets x x 0 1 2 0",
    "C#m/D#": "C#m/D# base-fret 0 frets x x 1 1 2 0",
    "C#m/E": "C#m/E base-fret 0 frets x x 2 1 2 x",
    "C#m/F": "C#m/F base-fret 0 frets 1 x 2 1 2 4",
    "C#m/F#": "C#m/F# base-fret 0 frets 2 x 2 1 2 x",
    "C#m/G": "C#m/G base-fret 0 frets 3 4 2 1 x x",
    "C#m/G#": "C#m/G# base-fret 0 frets 4 4 2 x x x",
    "D(4)": "D(4) base-fret 2 frets x 4 4 1 2 1",
    "Dm2": "Dm2 base-fret 2 frets x 4 2 1 4 4",
    "D13sus4": "D13sus4 base-fret 5 frets x 1 1 1 4 3",
    "Dm(ma9)": "Dm(ma9) base-fret 2 frets x 4 2 x 1 0",
    "Dm7(#5)": "Dm7(#5) base-fret 0 frets x x 0 3 1 1",
    "Dma7(#5)": "Dma7(#5) base-fret 0 frets x x 0 3 2 2",
    "Dma7(b5)": "Dma7(b5) base-fret 0 frets x x 0 1 2 2",
    "D/A#": "D/A# base-fret 0 frets x 1 4 2 3 2",
    "D/D#": "D/D# base-fret 0 frets x x 1 2 3 2",
    "D/F": "D/F base-fret 0 frets x x 3 2 3 2",
    "D/G#": "D/G# base-fret 0 frets 4 x 4 2 3 2",
    "Dm/A": "Dm/A base-fret 0 frets x x x 2 3 1",
    "Dm/A#": "Dm/A# base-fret 0 frets x 1 3 2 3 1",
    "Dm/B": "Dm/B base-fret 0 frets x 2 3 2 3 x",
    "Dm/C": "Dm/C base-fret 0 frets x 3 3 2 3 x",
    "Dm/C#": "Dm/C# base-fret 0 frets x 4 3 2 3 x",
    "Dm/D#": "Dm/D# base-fret 0 frets x x 1 2 3 1",
    "Dm/E": "Dm/E base-fret 0 frets 0 0 0 2 3 1",
    "Dm/F#": "Dm/F# base-fret 0 frets 2 x 3 2 3 x",
    "Dm/G": "Dm/G base-fret 0 frets 3 x 3 2 3 x",
    "Dm/G#": "Dm/G# base-fret 0 frets 4 x 3 2 3 x",
    "D#(4)": "D#(4) base-fret 3 frets x 4 4 1 2 1",
    "D#m2": "D#m2 base-fret 3 frets x 4 2 1 4 4",
    "D#dim": "D#dim base-fret 0 frets x x 1 2 4 2",
    "D#m6": "D#m6 base-fret 0 frets x x 1 3 1 2",
    "D#13sus4": "D#13sus4 base-fret 6 frets x 1 1 1 4 3",
    "D#m(ma9)": "D#m(ma9) base-fret 4 frets x 3 1 4 3 x",
    "D#m7(#5)": "D#m7(#5) base-fret 0 frets x x 1 4 2 2",
    "D#ma7(#5)": "D#ma7(#5) base-fret 0 frets x x 1 4 3 3",
    "D#ma7(b5)": "D#ma7(b5) base-fret 0 frets x x 1 2 3 3",
    "D#9(#5)": "D#9(#5) base-fret 5 frets x 2 1 2 2 3",
    "D#9(b5)": "D#9(b5) base-fret 5 frets x 2 1 2 2 1",
    "D#/A": "D#/A base-fret 0 frets x 0 1 3 4 3",
    "D#/B": "D#/B base-fret 0 frets x 2 1 3 4 3",
    "D#/C": "D#/C base-fret 0 frets x 3 1 3 4 3",
    "D#/C#": "D#/C# base-fret 0 frets x 4 x 3 4 3",
    "D#/D": "D#/D base-fret 0 frets x x 0 3 4 3",
    "D#/E": "D#/E base-fret 0 frets 0 x 1 3 4 3",
    "D#/F": "D#/F base-fret 0 frets 1 1 1 3 4 3",
    "D#/F#": "D#/F# base-fret 0 frets x x 4 3 4 3",
    "D#/G": "D#/G base-fret 0 frets 3 1 1 3 4 x",
    "D#/G#": "D#/G# base-fret 0 frets 4 x x 3 4 3",
    "D#m/A": "D#m/A base-fret 0 frets x 0 4 3 4 2",
    "D#m/A#": "D#m/A# base-fret 0 frets x 1 1 3 4 2",
    "D#m/B": "D#m/B base-fret 0 frets x 2 4 3 4 2",
    "D#m/C": "D#m/C base-fret 0 frets x 3 4 3 4 x",
    "D#m/C#": "D#m/C# base-fret 0 frets x 4 4 3 4 x",
    "D#m/D": "D#m/D base-fret 0 frets x x 0 3 4 2",
    "D#m/E": "D#m/E base-fret 0 frets 0 x 4 3 4 2",
    "D#m/F": "D#m/F base-fret 0 frets 1 1 1 3 4 2",
    "D#m/F#": "D#m/F# base-fret 0 frets 2 x 4 3 4 2",
    "D#m/G": "D#m/G base-fret 0 frets 3 1 1 3 x 2",
    "D#m/G#": "D#m/G# base-fret 0 frets 4 1 1 3 x 2",
    "E(4)": "E(4) base-fret 0 frets 0 0 2 1 0 0",
    "Em2": "Em2 base-fret 0 frets 0 2 4 0 0 0",
    "E13sus4": "E13sus4 base-fret 0 frets 0 0 0 2 2 2",
    "Em(ma9)": "Em(ma9) base-fret 0 frets 0 2 1 0 0 2",
    "Em7(#5)": "Em7(#5) base-fret 0 frets 0 3 0 0 3 0",
    "Ema7(#5)": "Ema7(#5) base-fret 0 frets 0 3 2 1 4 0",
    "Ema7(b5)": "Ema7(b5) base-fret 0 frets x x 2 3 4 4",
    "E/A#": "E/A# base-fret 0 frets x 1 2 4 x 4",
    "E/C": "E/C base-fret 0 frets x 3 2 4 x 4",
    "E/F": "E/F base-fret 0 frets 1 2 2 1 x 4",
    "E/G": "E/G base-fret 0 frets 3 2 2 4 x 4",
    "Em/A": "Em/A base-fret 0 frets x 0 2 0 0 0",
    "Em/A#": "Em/A# base-fret 0 frets x 1 2 4 x 3",
    "Em/B": "Em/B base-fret 0 frets x 2 2 4 x 3",
    "Em/C": "Em/C base-fret 0 frets x 3 2 4 x 3",
    "Em/C#": "Em/C# base-fret 0 frets x 4 2 4 x 3",
    "Em/D": "Em/D base-fret 0 frets x x 0 0 0 0",
    "Em/D#": "Em/D# base-fret 0 frets x x 1 0 0 0",
    "Em/F": "Em/F base-fret 0 frets 1 2 2 4 x 3",
    "Em/F#": "Em/F# base-fret 0 frets x x 4 0 0 0",
    "Em/G#": "Em/G# base-fret 0 frets 4 2 2 4 x 3",
    "F(4)": "F(4) base-fret 0 frets 1 1 3 2 1 1",
    "Fm2": "Fm2 base-fret 0 frets x x 3 1 1 3",
    "F11": "F11 base-fret 0 frets 1 0 1 3 x x",
    "F13sus4": "F13sus4 base-fret 0 frets 1 3 1 3 3 1",
    "Fm(ma9)": "Fm(ma9) base-fret 0 frets 1 3 2 1 1 3",
    "Fm7(#5)": "Fm7(#5) base-fret 0 frets 1 4 1 1 4 1",
    "Fma7(#5)": "Fma7(#5) base-fret 0 frets 1 x 2 2 2 1",
    "Fma7(b5)": "Fma7(b5) base-fret 0 frets 1 2 2 2 x 1",
    "F/B": "F/B base-fret 0 frets x 2 3 2 1 1",
    "F/C#": "F/C# base-fret 0 frets x 4 3 2 1 1",
    "F/F#": "F/F# base-fret 0 frets 2 x 3 2 1 1",
    "F/G#": "F/G# base-fret 0 frets 4 3 x 2 1 1",
    "Fm/A": "Fm/A base-fret 0 frets x 0 3 1 1 1",
    "Fm/A#": "Fm/A# base-fret 0 frets x 1 3 1 1 1",
    "Fm/B": "Fm/B base-fret 0 frets x 2 3 1 1 1",
    "Fm/C": "Fm/C base-fret 0 frets x 3 3 1 1 1",
    "Fm/C#": "Fm/C# base-fret 0 frets x 4 3 1 1 1",
    "Fm/D": "Fm/D base-fret 0 frets x x 0 1 1 1",
    "Fm/D#": "Fm/D# base-fret 0 frets x x 1 1 1 1",
    "Fm/E": "Fm/E base-fret 0 frets 0 3 3 1 1 1",
    "Fm/F#": "Fm/F# base-fret 0 frets 2 3 3 1 1 1",
    "Fm/G": "Fm/G base-fret 0 frets 3 3 3 1 1 1",
    "Fm/G#": "Fm/G# base-fret 0 frets x x x 1 1 1",
    "F#(4)": "F#(4) base-fret 0 frets 2 2 4 3 2 2",
    "F#m2": "F#m2 base-fret 0 frets x x 4 2 2 4",
    "F#aug": "F#aug base-fret 0 frets 2 x 4 3 3 2",
    "F#dim": "F#dim base-fret 0 frets 2 3 4 2 x x",
    "F#11": "F#11 base-fret 0 frets 2 1 2 4 x x",
    "F#13sus4": "F#13sus4 base-fret 0 frets 2 4 2 4 4 2",
    "F#m(ma9)": "F#m(ma9) base-fret 0 frets 2 4 3 2 2 4",
    "F#m7(#5)": "F#m7(#5) base-fret 0 frets 2 x 2 2 3 2",
    "F#ma7(#5)": "F#ma7(#5) base-fret 0 frets 2 x 3 3 3 2",
    "F#ma7(b5)": "F#ma7(b5) base-fret 0 frets 2 1 3 3 1 1",
    "F#/A": "F#/A base-fret 0 frets x 0 4 3 2 2",
    "F#/A#": "F#/A# base-fret 0 frets x x x 3 2 2",
    "F#/B": "F#/B base-fret 0 frets x 2 4 3 2 2",
    "F#/C": "F#/C base-fret 0 frets x 3 4 3 2 2",
    "F#/D": "F#/D base-fret 0 frets x x 0 3 2 2",
    "F#/D#": "F#/D# base-fret 0 frets x x 1 3 2 2",
    "F#/E": "F#/E base-fret 0 frets 0 4 4 3 2 2",
    "F#/F": "F#/F base-fret 0 frets x x 3 3 2 2",
    "F#/G": "F#/G base-fret 0 frets 3 x 4 3 2 2",
    "F#/G#": "F#/G# base-fret 0 frets 4 x 4 3 2 2",
    "F#m/A#": "F#m/A# base-fret 0 frets x 1 4 2 2 2",
    "F#m/B": "F#m/B base-fret 0 frets x 2 4 2 2 2",
    "F#m/C": "F#m/C base-fret 0 frets x 3 4 2 2 2",
    "F#m/C#": "F#m/C# base-fret 0 frets x 4 4 2 2 2",
    "F#m/D": "F#m/D base-fret 0 frets x x 0 2 2 2",
    "F#m/D#": "F#m/D# base-fret 0 frets x x 1 2 2 2",
    "F#m/E": "F#m/E base-fret 0 frets 0 0 4 2 2 2",
    "F#m/F": "F#m/F base-fret 0 frets x x 3 2 2 2",
    "F#m/G": "F#m/G base-fret 0 frets 3 4 4 2 2 2",
    "F#m/G#": "F#m/G# base-fret 0 frets 4 4 4 2 2 2",
    "G(4)": "G(4) base-fret 0 frets 3 3 x 4 3 3",
    "Gm2": "Gm2 base-fret 0 frets 3 1 x 2 3 x",
    "G13sus4": "G13sus4 base-fret 0 frets 3 3 3 0 3 0",
    "Gm(ma9)": "Gm(ma9) base-fret 0 frets 3 1 4 2 x x",
    "Gm7(#5)": "Gm7(#5) base-fret 0 frets 3 1 1 3 4 1",
    "Gma7(#5)": "Gma7(#5) base-fret 0 frets 3 2 4 x 4 2",
    "Gma7(b5)": "Gma7(b5) base-fret 0 frets 3 2 4 4 2 2",
    "G/A#": "G/A# base-fret 0 frets x 1 x 4 3 3",
    "G/C#": "G/C# base-fret 0 frets x 4 x 4 3 3",
    "G/D#": "G/D# base-fret 0 frets x x 1 4 3 3",
    "G/G#": "G/G# base-fret 0 frets 4 x x 4 3 3",
    "Gm/A": "Gm/A base-fret 0 frets x 0 0 3 3 3",
    "Gm/A#": "Gm/A# base-fret 0 frets x x x 3 3 3",
    "Gm/B": "Gm/B base-fret 0 frets x 2 x 3 3 3",
    "Gm/C": "Gm/C base-fret 0 frets x 3 x 3 3 3",
    "Gm/C#": "Gm/C# base-fret 0 frets x 4 x 3 3 3",
    "Gm/D": "Gm/D base-fret 0 frets x x 0 3 3 3",
    "Gm/D#": "Gm/D# base-fret 0 frets x x 1 3 3 3",
    "Gm/E": "Gm/E base-fret 0 frets 0 1 0 0 x x",
    "Gm/F": "Gm/F base-fret 0 frets x x 3 3 3 3",
    "Gm/F#": "Gm/F# base-fret 0 frets x x 4 3 3 3",
    "Gm/G#": "Gm/G# base-fret 0 frets 4 x x 3 3 3",
    "G#(4)": "G#(4) base-fret 0 frets 4 3 1 1 2 x",
    "G#m2": "G#m2 base-fret 0 frets 4 1 1 4 4 x",
    "G#aug": "G#aug base-fret 0 frets 4 x 2 1 1 4",
    "G#dim": "G#dim base-fret 0 frets 4 2 x 4 3 x",
    "G#13sus4": "G#13sus4 base-fret 0 frets 4 x 4 1 2 1",
    "G#m(ma9)": "G#m(ma9) base-fret 0 frets 4 2 x 3 4 3",
    "G#m7(#5)": "G#m7(#5) base-fret 0 frets 4 2 2 4 x 2",
    "G#ma7(#5)": "G#ma7(#5) base-fret 0 frets 4 x 2 1 1 3",
    "G#ma7(b5)": "G#ma7(b5) base-fret 0 frets 4 3 x 1 3 3",
    "G#/A": "G#/A base-fret 0 frets x 0 1 1 1 x",
    "G#/A#": "G#/A# base-fret 0 frets x 1 1 1 1 4",
    "G#/B": "G#/B base-fret 0 frets x 2 1 1 1 4",
    "G#/C": "G#/C base-fret 0 frets x 3 1 1 4 x",
    "G#/C#": "G#/C# base-fret 0 frets x 4 1 1 1 4",
    "G#/D": "G#/D base-fret 3 frets x 3 4 3 2 2",
    "G#/E": "G#/E base-fret 0 frets 0 3 1 1 x x",
    "G#/F": "G#/F base-fret 0 frets 1 3 1 1 1 4",
    "G#/F#": "G#/F# base-fret 0 frets 2 3 1 1 4 x",
    "G#/G": "G#/G base-fret 0 frets 3 3 1 1 4 x",
    "G#m/A": "G#m/A base-fret 0 frets x 0 1 4 4 4",
    "G#m/A#": "G#m/A# base-fret 0 frets x 1 1 4 4 4",
    "G#m/B": "G#m/B base-fret 0 frets x x x 4 4 4",
    "G#m/C": "G#m/C base-fret 0 frets x 3 1 4 4 4",
    "G#m/C#": "G#m/C# base-fret 0 frets x 4 x 4 4 4",
    "G#m/D": "G#m/D base-fret 0 frets x x 0 4 4 4",
    "G#m/D#": "G#m/D# base-fret 0 frets x x 1 4 4 4",
    "G#m/E": "G#m/E base-fret 0 frets 0 2 1 1 0 x",
    "G#m/F": "G#m/F base-fret 0 frets 1 2 1 1 4 x",
    "G#m/F#": "G#m/F# base-fret 0 frets x x 4 4 4 4",
    "G#m/G": "G#m/G base-fret 0 frets 3 2 1 1 4 x",
    "Am(4)": "Am(4) base-fret 0 frets x 0 0 2 1 0",
    "Am6/9": "Am6/9 base-fret 0 frets x 0 4 4 1 2",
    "Am6/7": "Am6/7 base-fret 0 frets x 0 2 0 1 2",
    "Am7(4)": "Am7(4) base-fret 0 frets x 0 0 0 1 0",
    "Ama11": "Ama11 base-fret 3 frets 3 2 4 x 1 x",
    "Ama13": "Ama13 base-fret 0 frets x 0 2 1 2 2",
    "A#m(4)": "A#m(4) base-fret 0 frets x 1 1 3 2 1",
    "A#m6/9": "A#m6/9 base-fret 3 frets 4 2 1 3 x 1",
    "A#m6/7": "A#m6/7 base-fret 0 frets x 1 3 1 2 3",
    "A#m7(4)": "A#m7(4) base-fret 0 frets x 1 1 1 2 1",
    "A#ma11": "A#ma11 base-fret 0 frets x 1 0 2 4 x",
    "A#ma13": "A#ma13 base-fret 0 frets x 1 3 2 3 3",
    "Bm(4)": "Bm(4) base-fret 0 frets x 2 2 4 3 2",
    "Bm6/9": "Bm6/9 base-fret 0 frets x 2 0 1 2 2",
    "Bm6/7": "Bm6/7 base-fret 0 frets x 2 4 2 3 4",
    "Bm7(4)": "Bm7(4) base-fret 0 frets x 2 2 2 3 2",
    "Bma11": "Bma11 base-fret 0 frets x 2 1 3 0 0",
    "Bma13": "Bma13 base-fret 0 frets x 2 4 3 4 4",
    "Cm(4)": "Cm(4) base-fret 0 frets x 3 3 x 4 3",
    "Cm6/9": "Cm6/9 base-fret 0 frets x 3 1 2 3 x",
    "Cm6/7": "Cm6/7 base-fret 3 frets x 1 3 1 2 3",
    "Cm7(4)": "Cm7(4) base-fret 0 frets x 3 1 3 1 1",
    "Cma11": "Cma11 base-fret 0 frets x 3 2 4 1 1",
    "Cma13": "Cma13 base-fret 2 frets x 2 1 3 4 4",
    "C#m(4)": "C#m(4) base-fret 0 frets x 4 2 1 2 2",
    "C#m6/9": "C#m6/9 base-fret 0 frets x 4 2 3 4 4",
    "C#m6/7": "C#m6/7 base-fret 0 frets x 4 2 3 0 0",
    "C#m7(4)": "C#m7(4) base-fret 0 frets x 4 2 4 2 2",
    "C#ma11": "C#ma11 base-fret 0 frets x 4 3 1 1 2",
    "C#ma13": "C#ma13 base-fret 3 frets x 2 4 3 4 4",
    "Dm(4)": "Dm(4) base-fret 2 frets x 4 2 1 2 2",
    "Dm6/9": "Dm6/9 base-fret 2 frets x 4 2 1 0 0",
    "Dm6/7": "Dm6/7 base-fret 0 frets x x 0 4 1 1",
    "Dm7(4)": "Dm7(4) base-fret 0 frets x x 0 0 1 1",
    "Dma11": "Dma11 base-fret 2 frets x 4 3 1 1 2",
    "Dma13": "Dma13 base-fret 4 frets x 2 1 3 4 4",
    "D#m(4)": "D#m(4) base-fret 3 frets x 4 2 1 2 2",
    "D#m6/9": "D#m6/9 base-fret 3 frets x 4 2 3 4 4",
    "D#m6/7": "D#m6/7 base-fret 5 frets x 2 4 2 3 4",
    "D#m7(4)": "D#m7(4) base-fret 0 frets x x 1 1 2 2",
    "D#ma11": "D#ma11 base-fret 0 frets x x 1 0 3 4",
    "D#ma13": "D#ma13 base-fret 5 frets x 2 4 3 4 4",
    "Em(4)": "Em(4) base-fret 0 frets 0 0 2 0 0 0",
    "Em6/9": "Em6/9 base-fret 0 frets 0 2 2 0 2 2",
    "Em6/7": "Em6/7 base-fret 0 frets 0 4 0 0 0 0",
    "Em7(4)": "Em7(4) base-fret 0 frets x x 2 2 3 3",
    "Ema11": "Ema11 base-fret 0 frets 0 x 4 2 4 4",
    "Ema13": "Ema13 base-fret 0 frets 0 2 1 1 2 0",
    "Fm(4)": "Fm(4) base-fret 0 frets 1 1 3 1 1 1",
    "Fm6/9": "Fm6/9 base-fret 0 frets 1 3 x 1 3 3",
    "Fm6/7": "Fm6/7 base-fret 0 frets 1 3 1 1 3 1",
    "Fm7(4)": "Fm7(4) base-fret 0 frets 1 1 1 1 1 1",
    "Fma11": "Fma11 base-fret 0 frets 1 0 2 3 1 0",
    "Fma13": "Fma13 base-fret 0 frets 1 x 2 2 3 1",
    "F#m(4)": "F#m(4) base-fret 0 frets 2 2 4 2 2 2",
    "F#m6/9": "F#m6/9 base-fret 0 frets 2 x 4 2 4 4",
    "F#m6/7": "F#m6/7 base-fret 0 frets 2 4 2 2 4 2",
    "F#m7(4)": "F#m7(4) base-fret 0 frets 2 2 2 2 2 2",
    "F#ma11": "F#ma11 base-fret 0 frets 2 1 3 4 x 1",
    "F#ma13": "F#ma13 base-fret 0 frets 2 1 3 1 4 1",
    "Gm(4)": "Gm(4) base-fret 0 frets 3 3 x 3 3 3",
    "Gm6/9": "Gm6/9 base-fret 0 frets 3 1 2 2 3 x",
    "Gm6/7": "Gm6/7 base-fret 0 frets 3 1 2 3 x 1",
    "Gm7(4)": "Gm7(4) base-fret 0 frets 3 3 3 3 3 3",
    "Gma11": "Gma11 base-fret 0 frets 3 2 4 x 1 x",
    "Gma13": "Gma13 base-fret 0 frets 3 2 4 0 0 0",
    "G#m(4)": "G#m(4) base-fret 0 frets 4 2 1 1 2 x",
    "G#m6/9": "G#m6/9 base-fret 0 frets 4 2 1 3 x 1",
    "G#m6/7": "G#m6/7 base-fret 0 frets 4 2 3 4 x 2",
    "G#m7(4)": "G#m7(4) base-fret 0 frets 4 4 4 4 4 4",
    "G#ma11": "G#ma11 base-fret 0 frets 4 3 x x 2 3",
    "G#ma13": "G#ma13 base-fret 0 frets 4 3 x 0 2 1"
}